<script>
  import { onMount } from "svelte";
  import {
    App,
    f7,
    f7ready,
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavRight,
    Link,
    Icon,
    List,
    ListItem,
    Badge,
    BlockTitle,
    Panel,
    View,
    Button,
    Block
  } from "framework7-svelte";
    export let f7route;
    export let f7router;
  let user,user_details=[],user_data=[], pending_user_data=[];

  onMount(() => {
    f7ready(async () => {
      user = f7route.query.user;
      user_data = JSON.parse(localStorage.getItem("user_data")) || [];
      pending_user_data = user_data.filter(function (el) {
        if (!el) return false;
        return el.account_status && el.account_status.toLowerCase() === "pending";
      });
      console.log(pending_user_data);
      localStorage.setItem("pending_user_data", JSON.stringify(pending_user_data));
    });
  });
  function user_info(i) {
    f7router.navigate(`/pending-users-full-details/?user=${i}`);
  }
  function convert_date(timestamp) {
    //console.log("Timestamp", timestamp);
    let t = parseInt(timestamp);
    //console.log("T:", t);
    var d = new Date(t);
    let final_date =
      d.getDate() +
      "/" +
      (d.getMonth() + 1) +
      "/" +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();

    return final_date;
  }
</script>

<Page class="admin-home" >
  <!-- <template id="zoom-template">
    <div id="zoom-template-wrapper">
      <div id="zoom-container">
        <p>hello</p>
      </div>
    </div>
  </template> -->
  <!-- <Panel right panelClose cover id="panel-right" panel-init >
    <View>
      <Page>
        <List>
          <ListItem
            link="/approved-users/"
            view=".view-main"
            panelClose
            title="Approved Users"
          />
          <ListItem
            link="/pending-users/"
            view=".view-main"
            panelClose
            title="Pending Users"
          />
          <ListItem
            link="/incomplete-users/"
            view=".view-main"
            panelClose
            title="Incomplete Users"
          />
        </List>
      </Page>
    </View>
  </Panel> -->
  <Navbar
    title="User Details"
    backLink={true}
    style="--f7-navbar-bg-color: white;
    --f7-navbar-text-color: black;
    --f7-navbar-link-color: black;"
    sliding={false}
  >
    <NavLeft />
  
    <NavRight>
      <Link>
        <p class="title-text">URL:desk.trdr.money</p>
      </Link>
      <Link iconOnly>
        <Icon ios="f7:bell_fill" aurora="f7:bell_fill" md="f7:bell_fill">
          <Badge color="blue">5</Badge>
        </Icon>
      </Link>
      <Link
        iconIos="f7:question_circle"
        iconAurora="f7:question_circle"
        iconMd="f7:question_circle"
      />
      <Link
        iconIos="f7:person_alt_circle"
        iconAurora="f7:person_alt_circle"
        iconMd="f7:person_alt_circle"
      />
      <!-- <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-right"
      /> -->
    </NavRight>

    <!-- <NavTitle>User Details</NavTitle> -->
  </Navbar>
  <div class="page-content padding">
    <BlockTitle large class="padding-left padding-top">Pending Users</BlockTitle>
    <Block>
      <div
        class="card data-table hoverTable"
      >
        <table>
          <thead>
            <tr>
              <th class="label-cell">No.</th>
              <!-- <th class="label-cell">First Name</th>
              <th>Last Name</th> -->
              <th>Username</th>
              <th>Date</th>
              <th>Mobile No.</th>
              <th>Pan</th>
              <th>Email</th>
              <th>IFSC</th>
              <th>Account Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
          {#each pending_user_data as user,i}
            <tr>
              <td>{i+1}</td>
              <td>{user.fullName ? user.fullName:(`${user.firstName} ${user.lastName}`)}</td>
              <td>{convert_date(user.account_created_ts)}</td>
              <!-- <td class="label-cell">{user.firstName}</td>
              <td>{user.lastName}</td> -->
              <td>{user.mobile}</td>
              <td>{user.pan}</td>
              <td>{user.emailAddress}</td>
              <td>{user.ifsc}</td>
              <td>{user.account_status}</td>
              <td class="display-block" width="100%" height="100%">
                <Button on:click={() => user_info(i)} color="blue"
                  >More <Icon
                    style="padding-left: 10%; font-weight: bold;"
                    f7="arrow_right"
                    color="blue"
                    size="14"
                  />
                </Button
                >
              </td>
            </tr>
          {/each }
          </tbody>
        </table>
        <!-- <div class="data-table-footer">
          <div class="data-table-rows-select">
            Per page:
            <div class="input input-dropdown">
              <select>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="all">All</option>
              </select>
            </div>
          </div>
          <div class="data-table-pagination">
            <span class="data-table-pagination-label">1-5 of 10</span>
            <a href="#" class="link disabled">
              <i class="icon icon-prev color-gray" />
            </a>
            <a href="#" class="link">
              <i class="icon icon-next color-gray" />
            </a>
          </div>
        </div> -->
      </div>
    </Block>
    

  </div>
</Page>

<style>
     .hoverTable{
    width:100%; 
    border-collapse: collapse; 
  }
    .hoverTable th{
background-color: #000;
    color: #fff;
  }
  .hoverTable tr:hover {
    background-color: #000;
    color: #fff;
  }
</style>
